import script from "./UserDetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailCard.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailCard.vue?vue&type=style&index=0&id=74d9da9f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d9da9f"]])

export default __exports__